// TODO: migrate this to a public backend
export const blacklist = [
    "memelandnft.club",
    "thememeland.xyz",
]